import { render, staticRenderFns } from "./SimilarProperties.vue?vue&type=template&id=493b398a&scoped=true"
import script from "./SimilarProperties.vue?vue&type=script&lang=js"
export * from "./SimilarProperties.vue?vue&type=script&lang=js"
import style0 from "./SimilarProperties.vue?vue&type=style&index=0&id=493b398a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b398a",
  null
  
)

export default component.exports